module.exports = __webpack_public_path__ + "img/arg_logo_white.65102769.png";